import { translate } from "src/utils/translate";

/**
 * Gestion du breadcrumb
 * @param  {any}    emitter [description]
 * @return {[type]}         [description]
 */
export default function Listener(emitter: any): any {
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/account',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: 'Account' },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/analytics',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Analytics') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/home',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { active: true, text: translate(routeParams.language,'Home') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/analytics/:analyticID/result',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { text: translate(routeParams.language,'Analytics'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics` },
        { active: true, text: translate(routeParams.language,'Analytics Item') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/analytics/:analyticID/form',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { text: translate(routeParams.language,'Analytics'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics` },
        { text: translate(routeParams.language,'Analytics Item'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics/:analyticID/result/` },
        { active: true, text: translate(routeParams.language,'Form') },
      ];
    },
  });
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/analytics/:analyticID/logs',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { text: translate(routeParams.language,'Analytics'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics` },
        { text: translate(routeParams.language,'Analytics Item'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics/:analyticID/logs/` },
        { active: true, text: translate(routeParams.language,'Logs') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/text',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Text extraction') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/face',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Face recognition') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/nlu',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Natural language understanding') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/inference/invoice',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Invoice') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/table',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Table extraction') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/inference/bank-statements',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Bank statements') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/inference/receipt',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Receipt') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/inference/liasse-fiscale',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Liasse fiscale') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/bounding-box',
    resolver: async ({ i18n, routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/home` },
        { active: true, text: translate(routeParams.language,'Bounding box') },
      ];
    },
  });
}



// WEBPACK FOOTER //
// ./src/listeners/breadcrumb/account.ts